import { BaseDto } from './base.dto'

import { FileDto } from './file.dto'
import { MallOrderDto } from './mall-order.dto'
import { PagingDto } from './paging.dto'
import { TenantCouponDto } from './tenant-coupon.dto'
import { TenantVoucherDto } from './tenant-voucher.dto'
import { TenantDto } from './tenant.dto'
import { UserDto } from './user.dto'

export enum OrderStatus {
  PENDING = 'pending',
  NEW = 'new',
  COMPLETED = 'completed',
  READY_FOR_PICKUP = 'ready_for_pickup',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
  SHIPPING = 'shipping',
  ACCEPTED = 'accepted',
  REFUND = 'refund',
  DROP_OFF = 'drop_off',
  ON_THE_WAY= 'on_the_way',
  OTHERS = 'others'
}

export enum OrderItemStockAdjustmentStatus {
  Pending = 'pending',
  Confirmed = 'confirmed',
  Rejected = 'rejected'
}

export enum OrderItemStockAdjustmentActivityName {
  AdjustByTenant = 'tenant_create_order_stock_adjustment',
  AcceptOrCancelByCustomer = 'customer_accept_cancel_order_stock_adjustment',
  AcceptOrCancelByAdmin = 'admin_accept_cancel_order_stock_adjustment'
}

export enum PaymentStatus {
  PAID = 'paid',
  UNPAID = 'unpaid'
}

export enum PaymentMethod {
  COD = 'cod',
  PAY_WAY = 'payway'
}


export class OrderDto extends BaseDto {
  tenantOrderNumber: string
  owner: UserDto
  discountTotal: number
  total: number
  paymentStatus: string
  items: OrderItemDto[]
  tenantCouponData: any
  tenantVoucherData: any
  couponTotal: number
  voucherTotal: number
  tenantVoucher: TenantVoucherDto
  tenantCoupon: TenantCouponDto
  tenant: TenantDto
  accepted: UserDto
  cancel: any
  reject: any
  mallVoucherShareTotal: number
  mallCouponShareTotal: number
  logs: any
}

export class OrderDetailDto extends BaseDto {
  paymentMethod: string
  paymentStatus: string
  status: string
  logs: any
  shippingAddress: any
  reject: any
  cancel: any
  reviewed: boolean
  owner: UserDto
  shippingTotal: number
  subTotal: number
  total: number
  items: OrderItemDto[]
  tenantOrderNumber: string
  discountTotal: number
  voucherTotal: number
  couponTotal: number
  tenantCouponData: any
  tenantVoucherData: any
  tenantVoucher: TenantVoucherDto
  tenantCoupon: TenantCouponDto
  mallOrder: MallOrderDto
  tenant: TenantDto
  mallVoucherShareTotal: number
  mallCouponShareTotal: number
  accepted: UserDto
  discountTotalAlt: number
  voucherTotalAlt: number
  couponTotalAlt: number
  subTotalAlt: number
  totalAlt: number
  mallVoucherShareTotalAlt: number
  mallCouponShareTotalAlt: number
}

export class OrderItemDto {
  id: string
  quantity: number
  unitPrice: number
  total: number
  totalAlt: number
  subTotal: number
  subTotalAlt: number
  reviewed: boolean
  unitSalePrice: number
  discountTotal: number
  discountTotalAlt: number
  productDescription: string
  productSlug: string
  thumbnail: FileDto
  productEnabled: boolean
  productName: string
  productAttributes: any[]
  status: string
  logs: any
  cancelled: any
}

export class CountStatusDto {
  totalOfNew: number
  totalOfAccpeted: number
  totalOfCancelled: number
  totalOfRejected: number
  totalOfRefund: number
  totalOfReadyForPickup: number
  totalOfDropOff: number
  totalOfShipping: number
  totalOfCompleted: number
}

export class FindOrderDto extends PagingDto {
  public searchText?: string
  public status?: string
  public startDate?: Date
  public endDate?: Date
}

export class OrderBadgeCountDto {
  newCount: number
  completedCount: number
  cancelledCount: number
  totalCount: number
}

export class OrderRejectDto {
  reason: any
  
  static create() {
    return new OrderRejectDto
  }
}

export class ExportOrderDto {
  statuses?: string[]
  startDate?: Date
  endDate?: Date
  timezone?: string
  email?: string
}

export class OrderQuantityDto extends BaseDto {
  productName: string
  adjustmentQuantity: number
  adjusted: any
  orderItem: OrderItemDto
  productId: string
  orderItemId: string
  status: string
  discountTotal: number
  subTotal: number
  total: number
  confirmedBy: UserDto
  adjustedBy: UserDto
}

export class UpdateOrderQuantityItemDto {
  orderItemId: string
  reason: string
  adjustmentQuantity: number
}

export class AdminConfirmUpdateQuantityItemDto {
  id: string
  status: string
}

export class AdminConfirmUpdateQuantityDto {
  tenantOrderId: string
  items: AdminConfirmUpdateQuantityItemDto[]
}